import { gql, useMutation, MutationHookOptions } from "@apollo/client";

export interface BulkDeleteExternalTransactionsMutationVariables {
  email: string;
  transactionIds: string[];
}

export interface BulkDeleteExternalTransactionsMutationResult {
  bulkDeleteExternalTransactions: number;
}

export const BULK_DELETE_EXTERNAL_TRANSACTIONS_MUTATION = gql`
  mutation bulkDeleteExternalTransactions(
    $email: String!
    $transactionIds: [String!]!
  ) {
    bulkDeleteExternalTransactions(
      email: $email
      transactionIds: $transactionIds
    )
  }
`;

export const useBulkDeleteExternalTransactionsMutation = (
  options?: MutationHookOptions<
    BulkDeleteExternalTransactionsMutationResult,
    BulkDeleteExternalTransactionsMutationVariables
  >
) => {
  return useMutation<
    BulkDeleteExternalTransactionsMutationResult,
    BulkDeleteExternalTransactionsMutationVariables
  >(BULK_DELETE_EXTERNAL_TRANSACTIONS_MUTATION, options);
};
